export class Llamada
{
    recomendado:string="";
    entrada:string="";//PILOTO
    tipo:string="";
    origen:string="";
    observ:string="";
    provincia:string="";
    poblacion:string="";
}